export const anonymousApplicantIds = {
  unregistered: -1,
  unspecified: 0,
};

export const anonymousApplicantData = new Map([
  [
    anonymousApplicantIds.unregistered,
    {
      name: 'Незарегистрированные',
      id: anonymousApplicantIds.unregistered,
      has: (request) => !request.clientId && request.clientName,
    },
  ],
  [
    anonymousApplicantIds.unspecified,
    {
      name: 'Не указан',
      id: anonymousApplicantIds.unspecified,
      has: (request) => !request.clientId && !request.clientName,
    },
  ],
]);
